<template>
  <div class="modal fade" id="manageStudentOrganizationsModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Manage {{ student.Name }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-left">
          <div v-if="availableOrganizations.length == 0">
            <h5>
              You do not have any groups to add a student to. Go to your
              organization and add a group to get started.
            </h5>
            <div class="col-auto">
              <button class="btn btn-primary" data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
          <label v-if="errorMessage != ''" class="text-danger">{{
            errorMessage
          }}</label>
          <transition
            v-if="availableOrganizations.length > 0"
            name="slide-fade"
            mode="out-in"
          >
            <form v-if="page == 1" @submit.prevent="nextPage()" key="name">
              <label>Groups</label>
              <div
                v-for="organization in availableOrganizations
                  .slice()
                  .sort($orderByName)"
                :key="organization.Organization_Id + 'organization'"
                class="form-group form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-bind:id="'org' + organization.Organization_Id"
                  v-bind:value="organization"
                  v-model="newStudentOrganizations"
                />
                <label
                  class="form-check-label"
                  v-bind:for="'org' + organization.Organization_Id"
                  >{{
                    Organizations.find(
                      o =>
                        o.Organization_Id == organization.Parent_Organization_Id
                    ).Name
                  }}
                  - {{ organization.Name }}</label
                >
              </div>
              <div class="text-right">
                <button type="submit" class="btn btn-primary">
                  Next
                </button>
              </div>
            </form>
            <form v-if="page == 2" @submit.prevent="nextPage" key="subjects">
              <div v-if="newStudentOrganizations.length > 0" class="form-group">
                <div
                  v-for="organization in newStudentOrganizations
                    .slice()
                    .sort($orderByName)"
                  :key="organization.Organization_Id + 'studentOrganization'"
                >
                  <label>{{ organization.Name }} Subjects</label>
                  <div v-if="organization.Subjects.length > 0">
                    <div
                      v-for="subject in organization.Subjects.slice().sort(
                        $orderByTitle
                      )"
                      :key="subject.Subject_Id + 'subject'"
                      class="form-group form-check"
                    >
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-bind:id="'sub' + subject.Subject_Id"
                        v-bind:value="subject"
                        v-model="newStudentSubjects"
                      />
                      <label
                        class="form-check-label"
                        v-bind:for="'sub' + subject.Subject_Id"
                        >{{ subject.Title }}</label
                      >
                    </div>
                  </div>
                  <p v-else>There are no subjects for this group.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="previousPage"
                  >
                    Back
                  </button>
                </div>
                <div class="col" />
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Next
                  </button>
                </div>
              </div>
            </form>

            <form v-if="page == 3" @submit.prevent="updateStudent" key="units">
              <div v-if="newStudentSubjects.length > 0" class="form-group">
                <div
                  v-for="subject in newStudentSubjects
                    .slice()
                    .sort($orderByTitle)"
                  :key="subject.Subject_Id + 'studentOrganization'"
                >
                  <label>{{ subject.Title }} Units</label>
                  <div v-if="subject.Units.length > 0">
                    <div
                      v-for="unit in subject.Units.slice().sort($orderByTitle)"
                      :key="unit.Unit_Id + 'subject'"
                      class="form-group form-check"
                    >
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-bind:id="'unit' + unit.Unit_Id"
                        v-bind:value="unit"
                        v-model="newStudentUnits"
                      />
                      <label
                        class="form-check-label"
                        v-bind:for="'unit' + unit.Unit_Id"
                        >{{ unit.Title }}</label
                      >
                    </div>
                  </div>
                  <p v-else>There are no units for this subject.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="previousPage"
                  >
                    Back
                  </button>
                </div>
                <div class="col" />
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Save Student
                  </button>
                </div>
              </div>
            </form>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  props: {
    Organizations: Array,
    Student: Object
  },
  data() {
    return {
      student: this.Student,
      availableOrganizations: [],
      newStudentOrganizations: [],
      currStudentOrganizations: [],
      newStudentSubjects: [],
      currStudentSubjects: [],
      newStudentUnits: [],
      currStudentUnits: [],
      page: 1,
      errorMessage: ""
    };
  },
  watch: {
    Student: function() {
      this.assignStudent();
    }
  },
  mounted() {
    this.assignStudent();
  },
  methods: {
    assignStudent() {
      this.student = this.Student;
      this.availableOrganizations = this.filterOrganizations();
      this.newStudentOrganizations = this.originalOrganizations();
      this.currStudentOrganizations = this.originalOrganizations();
      this.newStudentSubjects = this.originalSubjects();
      this.currStudentSubjects = this.originalSubjects();
      this.newStudentUnits = this.originalUnits();
      this.currStudentUnits = this.originalUnits();
    },
    filterOrganizations() {
      return this.Organizations.filter(o => o.Organization_Type_Id == 6 || o.Organization_Type_Id == 7);
    },
    originalOrganizations() {
      var existingIds = this.student.Organizations.map(o => o.Organization_Id);
      return this.Organizations.filter(o =>
        existingIds.includes(o.Organization_Id)
      );
    },
    originalSubjects() {
      var studentSubjectIds = this.student.Subjects.map(s => s.Subject_Id);
      var studentSubjects = [];
      this.Organizations.forEach(organization => {
        studentSubjects = studentSubjects.concat(
          organization.Subjects.filter(s =>
            studentSubjectIds.includes(s.Subject_Id)
          )
        );
      });
      return studentSubjects;
    },
    originalUnits() {
      var studentUnitIds = this.student.Student_Units.map(s => s.Unit.Unit_Id);
      var studentUnits = [];
      this.Organizations.forEach(organization => {
        organization.Subjects.forEach(subject => {
          studentUnits = studentUnits.concat(
            subject.Units.filter(u => studentUnitIds.includes(u.Unit_Id))
          );
        });
      });
      return studentUnits;
    },
    async updateStudent() {
      $("#manageStudentOrganizationsModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      await view
        .createStudentOrganizations(this.student.Student_Id)
        .then(async () => {
          await view
            .createStudentSubjects(this.student.Student_Id)
            .then(async () => {
              await view.createStudentUnits(this.Student).then(async () => {
                view.currStudentOrganizations = view.newStudentOrganizations;
                view.currStudentSubjects = view.newStudentSubjects;
                view.currStudentUnits = view.newStudentSubjects;
                var student = await view.$getStudent(this.student.Student_Id);
                view.$store.commit("updateLoading", false);
                view.$emit("student-updated", student);
                view.clearFields();
              });
            });
        })
        .catch(e => {
          console.log(e);
          $("#manageStudentOrganizationsModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    async createStudentOrganizations(studentId) {
      var view = this;
      var organizationsToAdd = this.newStudentOrganizations.filter(
        o => !this.currStudentOrganizations.includes(o)
      );
      if (organizationsToAdd.length > 0) {
        await view.$createStudentOrganizations(
          studentId,
          organizationsToAdd.map(o => o.Organization_Id)
        );
      }
      var organizationsToArchive = this.currStudentOrganizations.filter(
        o => !this.newStudentOrganizations.includes(o)
      );
      if (organizationsToArchive.length > 0) {
        await view.$removeStudentOrganizations(
          studentId,
          organizationsToArchive.map(o => o.Organization_Id)
        );
      }
    },
    async createStudentSubjects(studentId) {
      var view = this;
      var subjectsToAdd = this.newStudentSubjects.filter(
        s => !this.currStudentSubjects.includes(s)
      );
      if (subjectsToAdd.length > 0) {
        await view.$createStudentSubjects(
          studentId,
          subjectsToAdd.map(s => parseInt(s.Subject_Id))
        );
      }
      var subjectsToArchive = this.currStudentSubjects.filter(
        s => !this.newStudentSubjects.includes(s)
      );
      if (subjectsToArchive.length > 0) {
        var studentSubjectPairs = [
          {
            studentId: studentId,
            subjectIds: subjectsToArchive.map(s => s.Subject_Id)
          }
        ];
        await view.$archiveStudentSubjectsPairs(studentSubjectPairs);
      }
    },
    async createStudentUnits(student) {
      var view = this;
      var unitsToAdd = this.newStudentUnits.filter(
        s => !this.currStudentUnits.includes(s)
      );
      if (unitsToAdd.length > 0) {
        await view.$createStudentUnits(
          student.Student_Id,
          unitsToAdd.map(s => parseInt(s.Unit_Id))
        );
      }
      var unitsToArchive = this.currStudentUnits.filter(
        s => !this.newStudentUnits.includes(s)
      );
      if (unitsToArchive.length > 0) {
        var studentUnitPairs = [
          { student: student, unitIds: unitsToArchive.map(u => u.Unit_Id) }
        ];
        await view.$archiveStudentUnitsPairs(studentUnitPairs);
      }
    },
    nextPage() {
      switch (this.page) {
        case 1:
          if (this.newStudentOrganizations.length == 0) {
            this.errorMessage =
              "Please select at least one group for the new student.";
          } else {
            this.removeUnapplicableSubjects();
            this.addApplicableSubjects();
            this.page = 2;
            this.errorMessage = "";
          }
          break;
        case 2:
          this.removeUnapplicableUnits();
          this.addApplicableUnits();
          this.page = 3;
          break;
      }
    },
    previousPage() {
      this.page = this.page - 1;
    },
    removeUnapplicableSubjects() {
      var subjects = [].concat
        .apply(
          [],
          this.newStudentOrganizations.map(o => o.Subjects)
        )
        .map(s => s.Subject_Id);
      this.newStudentSubjects = this.newStudentSubjects.filter(s =>
        subjects.includes(s.Subject_Id)
      );
    },
    addApplicableSubjects() {
      var subjects = [].concat
        .apply(
          [],
          this.newStudentOrganizations.map(o => o.Subjects)
        )
        .map(s => s.Subject_Id);
      this.newStudentSubjects = this.currStudentSubjects.filter(s =>
        subjects.includes(s.Subject_Id)
      );
    },
    removeUnapplicableUnits() {
      var unitIds = [].concat
        .apply(
          [],
          this.newStudentSubjects.map(s => s.Units)
        )
        .map(s => s.Unit_Id);
      this.newStudentUnits = this.newStudentUnits.filter(u =>
        unitIds.includes(u.Unit_Id)
      );
    },
    addApplicableUnits() {
      var unitIds = [].concat
        .apply(
          [],
          this.newStudentSubjects.map(s => s.Units)
        )
        .map(s => s.Unit_Id);
      this.newStudentUnits = this.currStudentUnits.filter(u =>
        unitIds.includes(u.Unit_Id)
      );
    },
    clearFields() {
      this.newStudentOrganizations = this.currStudentOrganizations;
      this.newStudentSubjects = this.currStudentSubjects;
      this.newStudentUnits = this.currStudentUnits;
      this.page = 1;
    }
  }
};
</script>
